import { Directive, inject, input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthStore } from '../data-access/data-access-authentication/+state/auth.store';

@Directive({
  selector: '[authRole]',
})
export class RoleDirective implements OnInit {
  private readonly el = inject(TemplateRef);

  authRole = input<string | undefined>();

  private viewContainer = inject(ViewContainerRef);
  private authStore = inject(AuthStore);

  ngOnInit() {
    if (!this.authRole() || this.authRole() == this.authStore.data()?.role) {
      this.viewContainer.createEmbeddedView(this.el);
    } else {
      this.viewContainer.clear();
    }
  }
}
